import React from 'react'
import { FaCheckCircle } from 'react-icons/fa'

const SavePopup = () => {
  return (
   <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
               <div className="bg-white w-[500px] h-fit p-10 gap-10 rounded-lg flex flex-col items-center">
                    <FaCheckCircle className="text-6xl text-green-500 mb-3" />
                   <h1 className="text-lg font-bold text-left text-green-500">
                       Saved Successfully........
                   </h1>
                   </div>
               </div>
  )
}

export default SavePopup;